export const messages = {
  success:
    'The link has been copied successfully! Please share it with your team members.',
} as const;

export const QUERY_SHARE_ITEM_ID = 'sid';
export const QUERY_SHARE_TEAM_ID = 'tid';

export enum SharePreview {
  ALLOWED = 'allowed',
  FORBIDDEN = 'forbidden',
}
